export const mutations = {
  STORE_CONSIGNEES(state, consignees) {
    state.consignees = consignees;
  },

  STORE_CONSIGNEE_UPDATE(state, consigneeId) {
    let Consignee = state.consignees.find(function(consignee) {
      return consignee.id === consigneeId;
    });
    state.systemConsignee = Consignee;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/consignees/mutations.js